import React from 'react';
import PropTypes from 'prop-types';
import BureauVeritasLogo from 'assets/bv-logo-sm.svg';
import { Belt, Image } from 'Components';
import './InvoicesEmailHeader.css';

const InvoicesEmailHeader = props => (
  <Belt className="invoices-payment-details__header">
    <div className="invoices-payment-details__header__left">
      {props.title}
    </div>
    <div className="invoices-payment-details__header__right">
      <Image src={BureauVeritasLogo} alt="Bureau Veritas Logo" />
    </div>
  </Belt>
);

InvoicesEmailHeader.propTypes = {
  title: PropTypes.string,
};

export default InvoicesEmailHeader;



// WEBPACK FOOTER //
// ./src/components/InvoicesEmailHeader/InvoicesEmailHeader.jsx